/*
Documentation

This file renders the site home page

*/

import HeroHalf from 'components/markup/heros/Half';
import keys from 'keys';
import React from "react";
import { Helmet } from 'react-helmet';
import {  Col, Container, Row, Card, CardBody, CardHeader } from "reactstrap";
import { architeckCall } from 'database';
import { toggleAlert } from 'store/functions/system';
import archkFormatString from 'architeck-format-string';
import { Link } from 'react-router-dom'
import moment from 'moment';
import { connect } from 'react-redux';

class Home extends React.Component {

    state = {
        posts: [],
        main_post: {}
    }

    componentWillMount = async  () => {

        if(this.props.app_articles && this.props.app_articles.length) {

            this.setState({posts: this.props.app_articles})

        } else {

            const posts = await architeckCall({
                method: 'get',
                url: '/api/v1/archk_articles/list/?limit=10&find_by=post_status__published',
            })
    
            if(posts.success) {
                this.setState({posts: posts.data, loaded: true})
                


            } else {
                toggleAlert(true, 'warning', `Error: ${posts.message}.`, 'infinite' )
            }

        }

    }

    render() {

        const posts = this.state.posts
        let main_post = {post_author: {}}
        let other_posts = []

        if(posts && posts.length ) {
            main_post = posts.find(p => p._id === keys.PINNED_ARTICLE_ID) ?  posts.find(p => p._id === keys.PINNED_ARTICLE_ID) : {post_author: {}}
            other_posts = posts.filter(p => p._id !== keys.PINNED_ARTICLE_ID)
        }


        if(!posts) {
            return (

                <div className="py-6 text-center">
                    <h1>No posts found.</h1>
                </div>

            )
        }

                
        return (
        <>

            <Helmet>
                <title>{keys.COMPANY}</title>
                <meta name="description" content="Home Page" />
            </Helmet>

            <div className="main-content articles">

                <HeroHalf filter={.8} padding={window.innerWidth > 600 ? 100 : 50} theme="dark" img={main_post.post_image}>
                    <Container>

                        <Row>
                            <Col lg={7} mg={7}>

                                <h1 className="display-1 text-white">{main_post.post_name}</h1>

                                <p className="text-muted mb-0 text-sm mt-3">{ moment.unix(main_post.created_at).format("MMM D, YYYY")}</p>

                                <p className="text-white">{main_post.post_excerpt}</p>

                                <div className="mb-3">
                                    <span style={{display: 'inline-block'}} className="mr-3">
                                        <img style={{width: 50, borderRadius: 50, marginTop: -20}} src={main_post.post_author.picture_url} alt="" />
                                    </span>
                                    <span style={{display: 'inline-block', paddingTop: 10}}>
                                        <span className="text-white">
                                            Author <br /> 
                                            <b >{main_post.post_author.given_name} {main_post.post_author.family_name}</b>
                                        </span>
                                    </span>
                                </div>


                                <Link to={`/article/${main_post._id}`}  className="mt-2 btn btn-neutral">Read More</Link>
                            </Col>
                        </Row>

                      
                    </Container>
                </HeroHalf>

                <section className="bg-white section section-lg  py-7 bg-white text-center">
                    <Container >
                        <h1 className="display-2">The Architeck <b className="text-underline">Knowledge Base</b></h1>
                        <h2 className="display-4 font-weight-light">
                        At Architeck we are always striving to inform the people we work with and around to better understand the world of technology in business. Below you will find our knowledge vault shedding light on everything we know.
                        </h2>
                    </Container>
                </section>

                <section className="py-6">

                 
                    <Container>
                        <Row>
                            {other_posts && other_posts.length ? other_posts.map(p => (

                                <Col lg={4} className=" raise-2 article-card">
                                    
                                    <Link to={`/article/${p._id}`} >
                                        <div className="image" style={{ backgroundImage: 'url("'+p.post_image+'")'}} />
                                    </Link>

                                    <Card>
                                        <CardHeader style={{minHeight: 90}}>
                                            <h3 className="mb-0">{p.post_name}</h3>
                                        </CardHeader>
                                        <CardBody>
                                            <p className="">{archkFormatString(p.post_excerpt, 100, true)}...</p>
                                            <p className="text-sm">By <b>{p.post_author.given_name} {p.post_author.family_name}</b> on { moment.unix(p.created_at).format("MMM D, YYYY")}</p>
                                            <Link to={`/article/${p._id}`} className="mt-2 btn btn-success">Read More</Link>
                                        </CardBody>
                                    </Card>

                                </Col>
                            )) : null}
                        </Row>
                    </Container>
                </section>


            </div>

        </>
        );
    }
}


  
const mapStateToProps = state => {

    return {
  
      app_articles: state.articles.app_articles,
  
    };
};
  
export default connect(mapStateToProps, '')(Home);